import { CommandKind } from "../commands/CommandBuffer";
import type { GameContext } from "../core/GameContext";

/**
 * 输入模型固定为「左右移动 + 垂直发射，不转向」（决策 0016）。
 * 玩家横向跟随指针，发射方向恒为向上；不设蓄力，也没有第二种攻击方式。
 */
export class InputSystem {
  update(context: GameContext, dt: number): void {
    const { state, input } = context;
    const { width } = context.level.world;
    state.targetPlayerX = Math.max(32, Math.min(width - 32, input.pointerX));
    state.playerX +=
      (state.targetPlayerX - state.playerX) * Math.min(1, dt * 18);
    state.fireCooldown = Math.max(0, state.fireCooldown - dt);
    if (input.firing && state.fireCooldown <= 0) this.fireDrop(context);
  }

  fireDrop(context: GameContext): void {
    const { state, metrics, commands, level } = context;
    const type = level.world.drop;
    const definition = context.catalog.drops[type];
    const y = level.world.height - 61;
    // 角度抖动而非左右交替：固定交替会形成规律锯齿，看起来是机械的；随机偏角才像水花。
    // 走种子随机源——水落在哪直接决定哪只被灌满，这是玩法随机而非表现随机。
    const angle = (context.random.next() - 0.5) * level.world.sprayJitter;
    const speed = definition.speed;
    commands.lifecycle.push(
      CommandKind.SpawnDrop,
      -1,
      -1,
      type,
      state.playerX,
      y,
      Math.sin(angle) * speed,
      -Math.cos(angle) * speed,
    );
    // 不震屏：旧循环里一发子弹是一次打击，震一下合理；新循环里一滴水是浇灌，
    // 每秒十余滴各震一次会让整个画面持续抖动。震屏只留给爆浆。
    state.fireCooldown = level.world.fireInterval;
    metrics.shotsFired += 1;
  }
}
